import { Injectable, inject } from '@angular/core';
import { Observable, combineLatest, map, of } from 'rxjs';

import { UserSiteV1Model } from '@core/models/entities/implementations/user-site-v1';
import { SelectorsService } from '@core/services/selectors/selectors.service';
import { ArcEndpoints } from '@core/utils/geo-polyline.utils';

import { GeoLocation } from '@features/components/visualization/mapbox/models/map-data';

export function pairEndpoints(
  tail: GeoLocation | null,
  head: GeoLocation | null
): ArcEndpoints | null {
  return tail && head ? { tail, head } : null;
}

@Injectable({ providedIn: 'root' })
export class ArcEndpointsService {
  private readonly selectors = inject(SelectorsService);

  resolve$(
    tailUid: string | null,
    headUid: string | null,
    dataSpaceId: number
  ): Observable<ArcEndpoints | null> {
    if (!tailUid || !headUid) {
      return of(null);
    }
    return combineLatest([
      this.coords$(tailUid, dataSpaceId),
      this.coords$(headUid, dataSpaceId)
    ]).pipe(map(([tail, head]) => pairEndpoints(tail, head)));
  }

  private coords$(uid: string, dataSpaceId: number): Observable<GeoLocation | null> {
    return this.selectors
      .selectEntityByUid$('SITE', 'UserSite', uid, dataSpaceId)
      .pipe(map((entity) => (entity?.raw as UserSiteV1Model | undefined)?.coords ?? null));
  }
}
